'use client'
import { CardWrapper } from '@/components/ui/card-wrapper'
import { NewScrollCards } from '@/components/ui/new-scroll-cards'
import { useIsMobile } from '@/hooks/use-is-mobile'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'

import { STATS_CARDS } from '../data/stats'

export function Stats() {
  const t = useTranslations('BranchesPage')

  const isMobile = useIsMobile()

  return (
    <div className="mx-auto max-w-187.5">
      <h2 className="text-heading-5 md:text-heading-4 text-primary-600 mx-auto mb-6 max-w-137.5 text-center font-bold">
        {t('stats.title')}
      </h2>
      {isMobile ? (
        <NewScrollCards
          height="155px"
          gap="24px"
          className="mb-56 max-w-165 lg:mb-2.5"
          numCards={STATS_CARDS.length}
        >
          {STATS_CARDS.map((card, index) => (
            <div
              key={index}
              className={cn(
                'rounded-3xl text-center md:static',
                card.bgColor,
                card.textColor
              )}
            >
              <CardWrapper className="pb-4 md:flex-col md:gap-1">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/25 md:mb-1">
                  {card.icon}
                </div>
                <h3 className="text-body-2 mb-4 px-4 font-bold md:mb-1 md:px-0">
                  {t(card.title)}
                </h3>
              </CardWrapper>
            </div>
          ))}
        </NewScrollCards>
      ) : (
        <div className="grid grid-cols-2 gap-5">
          {STATS_CARDS.map((card, index) => (
            <div
              key={index}
              className={cn(
                'rounded-3xl text-center md:static',
                card.bgColor,
                card.textColor
              )}
            >
              <CardWrapper className="pb-4 md:flex-col md:gap-1">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/25 md:mb-1">
                  {card.icon}
                </div>
                <h3 className="text-body-2 mb-4 px-4 font-bold md:mb-1 md:px-0">
                  {t(card.title)}
                </h3>
              </CardWrapper>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
